import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  showAppLauncher = true;

  /**
   * Handles the activation event for a routed component.
   *
   * This method is typically triggered when a child route is activated.
   * It sets `showAppLauncher` to `false`, which can be used to hide the application launcher UI element.
   */
  onActivate() {
    this.showAppLauncher = false;
  }
}
